module.exports = __webpack_public_path__ + "img/logout-icon.d0bab6fc.svg";